/* index.tsx generated by @compiled/babel-plugin v0.37.1 */
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1bsb1osq%7Bwidth%3A100%25%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._ae4v1h6o%7Balign-content%3Acenter%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._7ehip0rx%3Afocus%7Bbox-shadow%3A0%200%200%202px%20var(--ds-border-focused%2C%234688ec)%20inset%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._5goinqa1%3Afocus%7Btext-decoration-style%3Asolid%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._4fprglyw%3Afocus%7Btext-decoration-line%3Anone%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1a3b1r31%3Afocus%7Btext-decoration-color%3AcurrentColor%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1hvw1o36%3Afocus%7Boutline-width%3Amedium%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._49pcglyw%3Afocus%7Boutline-style%3Anone%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._nt751r31%3Afocus%7Boutline-color%3AcurrentColor%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._16qs1x9r%7Bbox-shadow%3Ainset%202px%200%200%20var(--ds-border-selected%2C%231868db)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._bfhk15s3%7Bbackground-color%3Avar(--ds-background-selected%2C%23e9f2fe)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1dbz1x9r%3Ahover%7Bbox-shadow%3Ainset%202px%200%200%20var(--ds-border-selected%2C%231868db)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._irr31dpa%3Ahover%7Bbackground-color%3Avar(--ds-background-neutral-subtle-hovered%2C%230515240f)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._80omtlke%7Bcursor%3Apointer%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._u5f3fxbg%7Bpadding-right%3Aclamp(var(--ds-space-100%2C8px)%2Cvar(--link-picker-padding-right)%2C100%25)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._19bvsy6a%7Bpadding-left%3Aclamp(var(--ds-space-100%2C8px)%2Cvar(--link-picker-padding-left)%2C100%25)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._n3tdu2gc%7Bpadding-bottom%3Avar(--ds-space-100%2C8px)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._ca0qu2gc%7Bpadding-top%3Avar(--ds-space-100%2C8px)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._18u0idpf%7Bmargin-left%3A0%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._otyridpf%7Bmargin-bottom%3A0%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._2hwxidpf%7Bmargin-right%3A0%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._19pkidpf%7Bmargin-top%3A0%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._syaz1l7x%7Bcolor%3Avar(--ds-border%2C%230b120e24)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._o5721q9c%7Bwhite-space%3Anowrap%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._syazazsu%7Bcolor%3Avar(--ds-text-subtle%2C%23505258)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1bto1l2s%7Btext-overflow%3Aellipsis%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._18m915vq%7Boverflow-y%3Ahidden%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1reo15vq%7Boverflow-x%3Ahidden%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1e0c1txw%7Bdisplay%3Aflex%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._syazi7uo%7Bcolor%3Avar(--ds-text%2C%23292a2e)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._11c8wadc%7Bfont%3Avar(--ds-font-body-small%2Cnormal%20400%209pt%2F1pc%20%22Atlassian%20Sans%22%2Cui-sans-serif%2C-apple-system%2CBlinkMacSystemFont%2C%22Segoe%20UI%22%2CUbuntu%2C%22Helvetica%20Neue%22%2Csans-serif)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._p12fpxbi%7Bmax-width%3Avar(--ds-space-200%2C1pc)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._2hwxutpp%7Bmargin-right%3Avar(--ds-space-150%2C9pt)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._19pk1b66%7Bmargin-top%3Avar(--ds-space-050%2C4px)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1ul9pxbi%7Bmin-width%3Avar(--ds-space-200%2C1pc)%7D");
import { forwardRef, Fragment, type ForwardRefExoticComponent, type KeyboardEvent, type RefAttributes } from 'react';
import { type IntlShape, useIntl } from 'react-intl';
import { Text } from '@atlaskit/primitives/compiled';
import { type LinkSearchListItemData } from '../../../../../common/types';
/* eslint-disable-next-line @atlassian/tangerine/import/no-parent-imports */
import { transformTimeStamp } from '../../../transformTimeStamp';
export const testIds = {
  searchResultItem: 'link-search-list-item',
  searchResultIcon: 'link-search-list-item-icon'
};
const isSVG = (icon: string) => icon.startsWith('<svg') && icon.endsWith('</svg>');
const base64SVG = (icon: string) => `data:image/svg+xml;base64,${Buffer.from(icon).toString('base64')}`;
const itemIconStyles = null;
const listItemContextStyles = null;
const listItemContainerStyles = null;
const listItemContainerInnerStylesA11yRefresh = null;
const listItemContainerInnerStylesSeparatorLinkPickerRefresh = null;
const itemNameStyles = null;
const imgStyles = null;
const listItemBaseStyles = null;
const ListItemIcon = (props: {
  item: LinkSearchListItemData;
  intl: IntlShape;
}) => {
  const {
    item,
    intl
  } = props;
  const {
    icon,
    iconAlt
  } = item;
  if (!icon) {
    return null;
  }
  const alt = typeof iconAlt === 'string' ? iconAlt : intl.formatMessage(iconAlt);
  if (typeof icon !== 'string') {
    const Glyph = icon;
    return <span className={ax(["_1ul9pxbi _19pk1b66 _2hwxutpp"])}>
				<Glyph alt={alt} data-testid={testIds.searchResultIcon} />
			</span>;
  }
  return <span className={ax(["_1ul9pxbi _19pk1b66 _2hwxutpp"])}>
			<img data-testid={testIds.searchResultIcon} src={isSVG(icon) ? base64SVG(icon) : icon} alt={alt} className={ax(["_p12fpxbi"])} />
		</span>;
};
type SubtitleProps = {
  items: NonNullable<LinkSearchListItemData['subtitleItems']>;
};
const ListItemSubtitle = ({
  items: [firstItem, secondItem]
}: SubtitleProps) => {
  return <div data-testid={`${testIds.searchResultItem}-subtitle`} className={ax(["_11c8wadc _syazi7uo _1e0c1txw"])}>
			<div className={ax(["_1reo15vq _18m915vq _1bto1l2s"])}>
				<span className={ax(["_syazazsu _o5721q9c"])}>{firstItem}</span>
			</div>
			{secondItem && <div className={ax(["_syazazsu _o5721q9c"])}>
					<span className={ax(["_syaz1l7x"])}>
						<Fragment>&nbsp; •&nbsp; </Fragment>
					</span>
					<Fragment>{secondItem}</Fragment>
				</div>}
		</div>;
};
const getDefaultSubtitleItems = (item: LinkSearchListItemData, intl: IntlShape): LinkSearchListItemData['subtitleItems'] => {
  const container = item.container;
  const date = transformTimeStamp(intl, item.lastViewedDate, item.lastUpdatedDate);
  if (container) {
    if (date) {
      return [container, date];
    }
    return [container];
  }
  if (date) {
    return [date];
  }
  return undefined;
};
export type LinkSearchListItemProps = {
  item: LinkSearchListItemData;
  selected: boolean;
  active: boolean;
  tabIndex?: number;
  onSelect: (objectId: string) => void;
  onKeyDown: (e: KeyboardEvent<HTMLDivElement>) => void;
  onFocus: () => void;
  id?: string;
  role?: string;
  nameMaxLines?: number;
};
const listItemActive = null;
const listItemSelected = null;
const listItemFocusStyles = null;
export const LinkSearchListItem: ForwardRefExoticComponent<LinkSearchListItemProps & RefAttributes<HTMLDivElement>> = forwardRef<HTMLDivElement, LinkSearchListItemProps>(({
  item,
  selected,
  id,
  onSelect,
  tabIndex,
  onKeyDown,
  onFocus,
  nameMaxLines = 1
}: LinkSearchListItemProps, ref): JSX.Element => {
  const intl = useIntl();
  const handleSelect = () => onSelect(item.objectId);
  const subtitleItems = item.subtitleItems || getDefaultSubtitleItems(item, intl);
  return <div role="option" id={id} aria-selected={selected} data-testid={testIds.searchResultItem} onKeyDown={onKeyDown} onClick={handleSelect} onFocus={onFocus} tabIndex={tabIndex} ref={ref} className={ax(["_19pkidpf _2hwxidpf _otyridpf _18u0idpf _1e0c1txw _ca0qu2gc _n3tdu2gc _19bvsy6a _u5f3fxbg _80omtlke", !selected && "_irr31dpa _1dbz1x9r", selected && "_bfhk15s3 _16qs1x9r", "_nt751r31 _49pcglyw _1hvw1o36 _1a3b1r31 _4fprglyw _5goinqa1 _7ehip0rx"])}>
				<ListItemIcon item={item} intl={intl} />
				<div className={ax(["_1reo15vq _18m915vq _ae4v1h6o _1bsb1osq"])}>
					<Text maxLines={nameMaxLines}>
						<span data-testid={`${testIds.searchResultItem}-title`} title={item.name}>
							{item.name}
						</span>
					</Text>
					{subtitleItems && <ListItemSubtitle items={subtitleItems} />}
				</div>
			</div>;
});